import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'available-item',
        data: { pageTitle: 'baryApp.availableItem.home.title' },
        loadChildren: () => import('./available-item/available-item.module').then(m => m.AvailableItemModule),
      },
      {
        path: 'basket',
        data: { pageTitle: 'baryApp.basket.home.title' },
        loadChildren: () => import('./basket/basket.module').then(m => m.BasketModule),
      },
      {
        path: 'basket-order',
        data: { pageTitle: 'baryApp.basketOrder.home.title' },
        loadChildren: () => import('./basket-order/basket-order.module').then(m => m.BasketOrderModule),
      },
      {
        path: 'commercial',
        data: { pageTitle: 'transporterMember.home.title' },
        loadChildren: () => import('./commercial/transporter-member.module').then(m => m.TransporterMemberModule),
      },
      {
        path: 'customer',
        data: { pageTitle: 'baryApp.customer.home.title' },
        loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule),
      },
      {
        path: 'delivery-step',
        data: { pageTitle: 'baryApp.deliveryStep.home.title' },
        loadChildren: () => import('./delivery-step/delivery-step.module').then(m => m.DeliveryStepModule),
      },
      {
        path: 'directional-code',
        data: { pageTitle: 'baryApp.directionalCode.home.title' },
        loadChildren: () => import('./directional-code/directional-code.module').then(m => m.DirectionalCodeModule),
      },
      {
        path: 'edi-history',
        data: { pageTitle: 'baryApp.ediHistory.home.title' },
        loadChildren: () => import('./edi-history/edi-history.module').then(m => m.EdiHistoryModule),
      },
      {
        path: 'gazole-tax-value',
        data: { pageTitle: 'baryApp.gazoleTaxValue.home.title' },
        loadChildren: () => import('./gazole-tax-value/gazole-tax-value.module').then(m => m.GazoleTaxValueModule),
      },
      {
        path: 'import-history',
        data: { pageTitle: 'baryApp.importHistory.home.title' },
        loadChildren: () => import('./import-history/import-history.module').then(m => m.ImportHistoryModule),
      },
      {
        path: 'insurance-item',
        data: { pageTitle: 'baryApp.insuranceItem.home.title' },
        loadChildren: () => import('./insurance-item/insurance-item.module').then(m => m.InsuranceItemModule),
      },
      {
        path: 'offer',
        data: { pageTitle: 'baryApp.offer.home.title' },
        loadChildren: () => import('./offer/offer.module').then(m => m.OfferModule),
      },
      {
        path: 'offer-description-item',
        data: { pageTitle: 'baryApp.offerDescriptionItem.home.title' },
        loadChildren: () => import('./offer-description-item/offer-description-item.module').then(m => m.OfferDescriptionItemModule),
      },
      {
        path: 'payment-file-queue',
        data: { pageTitle: 'baryApp.paymentFileQueue.home.title' },
        loadChildren: () => import('./payment-file-queue/payment-file-queue.module').then(m => m.PaymentFileQueueModule),
      },
      {
        path: 'payment-transaction',
        data: { pageTitle: 'baryApp.paymentTransaction.home.title' },
        loadChildren: () => import('./payment-transaction/payment-transaction.module').then(m => m.PaymentTransactionModule),
      },
      {
        path: 'pricing',
        data: { pageTitle: 'baryApp.pricing.home.title' },
        loadChildren: () => import('./pricing/pricing.module').then(m => m.PricingModule),
      },
      {
        path: 'pricing-item',
        data: { pageTitle: 'pricingItem.home.title' },
        loadChildren: () => import('./pricing-item/pricing-item.module').then(m => m.PricingItemModule),
      },
      {
        path: 'pricing-option',
        data: { pageTitle: 'baryApp.pricingOption.home.title' },
        loadChildren: () => import('./pricing-option/pricing-option.module').then(m => m.PricingOptionModule),
      },
      {
        path: 'quotation-history',
        data: { pageTitle: 'baryApp.quotationHistory.home.title' },
        loadChildren: () => import('./quotation-history/quotation-history.module').then(m => m.QuotationHistoryModule),
      },
      {
        path: 'registered-address',
        data: { pageTitle: 'baryApp.registeredAddress.home.title' },
        loadChildren: () => import('./registered-address/registered-address.module').then(m => m.RegisteredAddressModule),
      },
      {
        path: 'special-place',
        data: { pageTitle: 'baryApp.specialPlace.home.title' },
        loadChildren: () => import('./special-place/special-place.module').then(m => m.SpecialPlaceModule),
      },
      {
        path: 'special-place-list',
        data: { pageTitle: 'baryApp.specialPlaceList.home.title' },
        loadChildren: () => import('./special-place-list/special-place-list.module').then(m => m.SpecialPlaceListModule),
      },
      {
        path: 'special-place-pricing',
        data: { pageTitle: 'baryApp.specialPlacePricing.home.title' },
        loadChildren: () => import('./special-place-pricing/special-place-pricing.module').then(m => m.SpecialPlacePricingModule),
      },
      {
        path: 'special-place-pricing-item',
        data: { pageTitle: 'baryApp.specialPlacePricingItem.home.title' },
        loadChildren: () => import('./special-place-pricing-item/special-place-pricing-item.module').then(m => m.SpecialPlacePricingItemModule),
      },
      {
        path: 'task',
        data: { pageTitle: 'baryApp.task.home.title' },
        loadChildren: () => import('./task/task.module').then(m => m.TaskModule),
      },
      {
        path: 'translation',
        data: { pageTitle: 'baryApp.translation.home.title' },
        loadChildren: () => import('./translation/translation.module').then(m => m.TranslationModule),
      },
      {
        path: 'transport',
        data: { pageTitle: 'baryApp.transport.home.title' },
        loadChildren: () => import('./transport/transport.module').then(m => m.TransportModule),
      },
      {
        path: 'transporter',
        data: { pageTitle: 'transporter.home.title' },
        loadChildren: () => import('./transporter/transporter.module').then(m => m.TransporterModule),
      },
      {
        path: 'transporter-configuration',
        data: { pageTitle: 'transporterConfiguration.home.title' },
        loadChildren: () => import('./transporter-configuration/transporter-configuration.module').then(m => m.TransporterConfigurationModule),
      },
      {
        path: 'transport-incident',
        data: { pageTitle: 'baryApp.transportIncident.home.title' },
        loadChildren: () => import('./transport-incident/transport-incident.module').then(m => m.TransportIncidentModule),
      },
      {
        path: 'transport-incident-item',
        data: { pageTitle: 'baryApp.transportIncidentItem.home.title' },
        loadChildren: () => import('./transport-incident-item/transport-incident-item.module').then(m => m.TransportIncidentItemModule),
      },
      {
        path: 'transport-item',
        data: { pageTitle: 'baryApp.transportItem.home.title' },
        loadChildren: () => import('./transport-item/transport-item.module').then(m => m.TransportItemModule),
      },
      {
        path: 'transport-order',
        data: { pageTitle: 'baryApp.transportOrder.home.title' },
        loadChildren: () => import('./transport-order/transport-order.module').then(m => m.TransportOrderModule),
      },
      {
        path: 'transport-order-item',
        data: { pageTitle: 'baryApp.transportOrderItem.home.title' },
        loadChildren: () => import('./transport-order-item/transport-order-item.module').then(m => m.TransportOrderItemModule),
      },
      {
        path: 'cut-off',
        data: { pageTitle: 'baryApp.cutOff.home.title' },
        loadChildren: () => import('./cut-off/cut-off.module').then(m => m.CutOffModule),
      },
      {
        path: 'ref-adr',
        data: { pageTitle: 'baryApp.refAdr.home.title' },
        loadChildren: () => import('./ref-adr/ref-adr.module').then(m => m.RefAdrModule),
      },
      {
        path: 'transport-extra-condition',
        data: { pageTitle: 'baryApp.transportExtraCondition.home.title' },
        loadChildren: () => import('./transport-extra-condition/transport-extra-condition.module').then(m => m.TransportExtraConditionModule),
      },
      {
        path: 'acceptance',
        data: { pageTitle: 'baryApp.acceptance.home.title' },
        loadChildren: () => import('./acceptance/acceptance.module').then(m => m.AcceptanceModule),
      },
      {
        path: 'user-data',
        data: { pageTitle: 'baryApp.userData.home.title' },
        loadChildren: () => import('./user-data/user-data.module').then(m => m.UserDataModule),
      },
      {
        path: 'offer-handling-type',
        data: { pageTitle: 'baryApp.offerHandlingType.home.title' },
        loadChildren: () => import('./offer-handling-type/offer-handling-type.module').then(m => m.OfferHandlingTypeModule),
      },
      {
        path: 'ref-dimension',
        data: { pageTitle: 'baryApp.refDimension.home.title' },
        loadChildren: () => import('./ref-dimension/ref-dimension.module').then(m => m.RefDimensionModule),
      },
      {
        path: 'theme',
        data: { pageTitle: 'baryApp.theme.home.title' },
        loadChildren: () => import('./theme/theme.module').then(m => m.ThemeModule),
      },
      /* jhipster-needle-add-entity-route - JHipster will add entity modules routes here */
    ]),
  ],
})
export class EntityRoutingModule {}
